<template>
  <div class="main-left-top">
    <div class="main-left-header" @click="toIndexPath">
      <span class="line"></span>
      {{$t('apiDoc.极兔API简介')}}
    </div>

    <div class="main-left-aside">
      <el-menu router ref="openApiMenu" active-text-color="#C31422" :default-active="activeIndex == '/apiDoc/index'?null:activeIndex" class="api-menu-vertical">
        <el-submenu v-for="(menuItem,menuIndex) in asideList" :index="`menu${menuIndex}`" :key="menuIndex">
          <template slot="title">
            <span>{{$t(`apiDoc.${menuItem.title}`)}}</span>
          </template>
          <el-menu-item v-for="subItem in menuItem.subTitle" :key="subItem.path" :index="subItem.path">{{$t(`apiDoc.${subItem.title}`)}}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      asideList: [
        // {
        //   title: "基础信息",
        //   subTitle: [
        //     {
        //       title: "获取极兔省市区",
        //       path: "/apiDoc/basic",
        //     },
        //   ],
        // },
        {
          title: "订单服务",
          subTitle: [
            {
              title: "创建订单",
              path: "/apiDoc/orderserve/create",
            },
            {
              title: "查询订单",
              path: "/apiDoc/orderserve/query",
            },
            {
              title: "取消订单",
              path: "/apiDoc/orderserve/cancel",
            },
            {
              title: "订单状态回传",
              path: "/apiDoc/orderserve/statusFeedback",
            },
            {
              title: '面单模版查询',
              path: "/apiDoc/orderserve/expressquery",
            },
            {
              title: '面单模版查询（新）',
              path: "/apiDoc/orderserve/expressquerynew",
            },
            {
              title: '退回件申请',
              path: "/apiDoc/orderserve/returnApplication",
            },
            {
              title: '退换货接口',
              path: "/apiDoc/orderserve/returnAndExchange",
            },
            {
              title: '出口国际件',
              path: "/apiDoc/orderserve/internationalExport",
            }
            // {
            //   title: "散客寄件",
            //   path: "/apiDoc/orderserve/addLooseOrder",
            // },
          ],
        },

        // {
        //   title: "电子面单",
        //   subTitle: [
        //     {
        //       title: "电子面单账号检验",
        //       path: "/apiDoc/vip/query",
        //     },
        //     {
        //       title: "电子面单余额查询",
        //       path: "/apiDoc/vip/balance",
        //     },
        //     {
        //       title: "获取电子面单",
        //       path: "/apiDoc/vip/getwaybill",
        //     },
        //   ],
        // },
        {
          title: "物流轨迹",
          subTitle: [
            {
              title: "物流轨迹查询",
              path: "/apiDoc/logistics/query",
            },
            {
              title: "物流轨迹订阅",
              path: "/apiDoc/logistics/subscribe",
            },
            {
              title: "物流轨迹回传",
              path: "/apiDoc/logistics/statusFeedback",
            },
          ],
        },
        {
          title: "其他服务",
          subTitle: [
            // {
            //   title: "超区查询",
            //   path: "/apiDoc/other/cover",
            // },
            // {
            //   title: "收派范围查询",
            //   path: "/apiDoc/other/pca",
            // },
            // {
            //   title: "网点信息及三段码查询",
            //   path: "/apiDoc/other/getInfo",
            // },
            // {
            //   title: "结算账单回传",
            //   path: "/apiDoc/other/settlementReturn",
            // },
            // {
            //   title: "实名制信息上传",
            //   path: "/apiDoc/other/realNameSaveInfo",
            // },
            // {
            //   title: "运费计算",
            //   path: "/apiDoc/other/freight",
            // },
            {
              title: "三段码查询",
              path: "/apiDoc/other/threeSegmentCode",
            },
            {
              title: '快件预报',
              path: '/apiDoc/other/expressDelivery'
            },
            {
              title: '快件预报删除',
              path: '/apiDoc/other/expressDeliveryDelete'
            },
            {
              title: '航空预报',
              path: '/apiDoc/other/flight'
            },
            {
              title: '预估运费查询',
              path: '/apiDoc/other/freightCost'
            },
            {
              title: '代收货款订阅',
              path: '/apiDoc/other/subscribe'
            },
            {
              title: '代收货款回传',
              path: '/apiDoc/other/subscribeOther'
            },
            {
              title: '预约派送',
              path: '/apiDoc/other/recheduleDelivery'
            }
          ],
        },
      ],
    };
  },
  methods: {
    toIndexPath() {
      if (this.$route.path != "/apiDoc/index") {
        this.$router.push("/apiDoc/index");
        this.$refs.openApiMenu.activeIndex = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.api-menu-vertical {
  border-right: none;
  ::v-deep .el-submenu__title {
    font-weight: 600;
  }
  ::v-deep .el-menu-item{
    max-width: 100%;
    white-space: normal;
    display: flex;
    align-items: center;
    line-height: 1.2;
    &.is-active {
      font-weight: 600;
    }
  }
  ::v-deep .el-menu-item.is-active {
    font-weight: 600;
  }
}
.main-left-top {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main-left-header {
  position: relative;
  width: 100%;
  border-bottom: 1px solid $table-border-color;
  color: #2b2d42;
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  padding: 22px 0 22px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: #fff;
  .line {
    width: 4px;
    height: 28px;
    background: $theme-color;
    border-radius: 2px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 22px;
  }
}

.main-left-aside {
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
  max-height: 700px;
  .main-left-aside-item {
    .title {
      font-size: 14px;
      color: #2b2d42;
      box-sizing: border-box;
      padding: 10px 20px;
      line-height: 14px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 50px;
      text-align: center;
      .subTitle_click {
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  .active {
    color: $theme-color;
  }
}
[dir="rtl"] .main-left-top  {
  .main-left-header {
    padding: 22px 20px 22px 5px;
    .line {
      left: inherit;
      right: 0;
    }
  }
  .el-menu{
    padding: 0;
  }
}
 [dir="rtl"] .main-left-top ::v-deep .el-submenu__icon-arrow{
    left: 20px;
    right: inherit;
  }
</style>
